'use client';

import { Container } from 'components/shared';
import { useContext, useRef } from 'react';
import { SleepContributorModal } from './SleepContributorModal';
import { SleepStagesModal } from './SleepStagesModal';
import { SleepScoreModal } from './SleepScoreModal';
import { MobileSleepComponent } from './MobileSleepComponent';
import { DesktopSleepComponent } from './DesktopSleepComponent';
import { AdvancedMetricsModal } from './AdvancedMetricsModal';
import { MagicModalNewContext } from 'components/shared/MagicModalNew';
import { analytics } from 'lib/analytics/analytics';
import styles from './index.module.css';

export const UnderstandYourSleep = ({
  className,
  htmlId,
}: {
  className?: string;
  htmlId?: string;
}) => {
  const MagicModalNewClient = useContext(MagicModalNewContext);

  const handleSleepScoreModal = () => {
    analytics.track('sleep score modal - CLICK');
    MagicModalNewClient.set(<SleepScoreModal />);
    MagicModalNewClient.show();
  };

  const handleSleepStageModal = () => {
    analytics.track('sleep stages modal - CLICK');
    MagicModalNewClient.set(<SleepStagesModal />);
    MagicModalNewClient.show();
  };

  const handleSleepContributorModal = () => {
    analytics.track('sleep contributor modal - CLICK');
    MagicModalNewClient.set(<SleepContributorModal />);
    MagicModalNewClient.show();
  };

  const handleAdvancedMetricsModal = () => {
    analytics.track('advanced modal - CLICK');
    MagicModalNewClient.set(<AdvancedMetricsModal />);
    MagicModalNewClient.show();
  };

  const rootRef = useRef<HTMLDivElement>(null);

  return (
    <section
      className={className ? `${styles.root} ${className}` : styles.root}
      id={htmlId}
      ref={rootRef}
    >
      <Container>
        {/* both branches render; CSS picks one at 993px (useWindowSize is 0 on SSR) */}
        <DesktopSleepComponent
          className="sleep-desktop"
          handleSleepScore={handleSleepScoreModal}
          handleSleepStage={handleSleepStageModal}
          handleSleepContributor={handleSleepContributorModal}
          handleAdvancedMetrics={handleAdvancedMetricsModal}
        />
        <MobileSleepComponent
          className="sleep-mobile"
          handleSleepScore={handleSleepScoreModal}
          handleSleepStage={handleSleepStageModal}
          handleSleepContributor={handleSleepContributorModal}
          handleAdvancedMetrics={handleAdvancedMetricsModal}
        />
      </Container>

      {/* <MagicModal /> */}
    </section>
  );
};
